import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Public web application configuration for the existing Firebase project.
const app = initializeApp({
  apiKey: 'AIzaSyCpYwMTGXiRYgK8INYqiX5uLanfPGvyFZE',
  appId: '1:833231691799:web:e255267530aa537a453c52',
  authDomain: 'lithilexicon.firebaseapp.com',
  measurementId: 'G-ZBERZ5LZQK',
  messagingSenderId: '833231691799',
  projectId: 'lithilexicon',
  storageBucket: 'lithilexicon.firebasestorage.app'
});

export const auth = getAuth(app);
export const db = getFirestore(app);
